import { useState, useCallback } from 'react';
import { Job } from '../../firestore_model';
import { useInjection } from '../../../di_container/InjectionProvider';
import { Constants } from '../../../common/constants';
export const useAdmin = () => {
    const { container } = useInjection();
    const { pagination } = Constants;
    // State
    const [loading, setLoading] = useState(false);
    const columns = [
        { id: 'corporateName', label: '契約者名', minWidth: 120 },
        { id: 'facilityName', label: '施設名', minWidth: 120 },
        { id: 'facilityDiv', label: '施設区分', minWidth: 80 },
        { id: 'address', label: '住所', minWidth: 120 },
        { id: 'email', label: 'メールアドレス', minWidth: 120 },
        { id: 'tel', label: '電話番号', minWidth: 80 },
        { id: 'detailButton', label: '', minWidth: 80, align: 'right' },
    ];
    const loadClinicList = useCallback(async (lastDocument) => {
        setLoading(true);
        try {
            const firestoreRepository = container.resolve('FirestoreRepository');
            const result = await firestoreRepository.loadDocuments({
                path: Job.Clinic.collectionReference().path,
                isGroup: false,
                limit: pagination.limit,
                startAfter: lastDocument,
                orderBy: {
                    fieldPath: 'createdAt',
                    directionStr: 'desc',
                },
            });
            setLoading(false);
            return {
                data: result.docs.map((item) => Job.Clinic.fromSnapshot(item)),
                lastDocument: result.lastDocument,
            };
        }
        catch (e) {
            setLoading(false);
            throw e;
        }
    }, []);
    const updateClinic = useCallback(async (clinic) => {
        if (loading)
            return;
        setLoading(true);
        try {
            await clinic.update();
        }
        catch (e) {
            setLoading(false);
            throw e;
        }
        setLoading(false);
    }, []);
    return {
        loadClinicList,
        loading,
        columns,
        updateClinic,
    };
};
